
import React, { useEffect, useState } from 'react'
import MainCalendar from './MainCalendar'
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import ModalPopup from '../common/Modal';
import deleteGif from "../../assets/gifs/delete.gif";
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { useDispatch, useSelector } from 'react-redux';
import { message } from '../../redux/actions/toastActions';
import DeleteModal from '../common/DeleteModal';
import { isPermission, isRole } from '../../redux/selectors/authSelector';

const Academic = () => {
  const [formData, setFormData] = useState({
    image: ""
  });
  const [openMenu, setOpenMenu] = useState(false);
  const [imageSizeMsg, setImageSizeMsg] = useState("");
  const [file, setFile] = useState(false);
  const [previewURL, setPreviewURL] = useState(null);
  const [modalForm, setModalForm] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const dispatch = useDispatch()
  const [refresh, setRefresh] = useState(false)
  const [isLoading, setIsloading] = useState(false)
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false)
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole)
  console.log("permissions", permissions)
  const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;
  const deletePermission = role == "schooladmin" || permissions && permissions?.includes('delete_Education') || false;


  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFile(true);
    setFormData((prev) => ({ ...prev, image: file }));
    setPreviewURL(URL.createObjectURL(file)); // For round preview
  };

  const handleDelete = (id) => {
    setIsloading(true);
    Postdata(HttpService.academic_calendar_delete, { id: id })
      .then((response) => {
        if (response.status === 200) {
          setRefresh(!refresh);
          // dispatch(message(response.message));
          setFormData({ ...formData, image: "" })
          setPreviewURL(null)

        } else {
          dispatch(message(response.message));
        }
        setIsloading(false);
      })
  };

  const handleSave = () => {
    const imageFile = formData.image;
    if (imageFile && imageFile.size > 5 * 1024 * 1024) { 
      setImageSizeMsg("Image size cannot exceed 5 MB");
      return; 
    }
    setImageSizeMsg("");
    setIsloading(true);
    Postdata(HttpService.academic_calendar_add, formData)
      .then((response) => {
        if (response.status === 200) {
          setRefresh(!refresh);
          // dispatch(message(response.message));
        } else {
          dispatch(message(response.message));
        }
        setIsloading(false);
      })
  }

  const fetchData = () => {
    setIsloading(true);
    Postdata(HttpService.academic_calendar_list)
      .then((response) => {
        if (response.status === 200) {
          setFormData(response.data.academics[0]);
          console.log("response.data.academics[0]", response.data.academics[0])
          response.data.academics[0]?.image && setPreviewURL(response.data.academics[0]?.image);
          
        } else {
          dispatch(message(response.message));
        }
        setIsloading(false);
      })
      .catch((e) => {
        setIsloading(false);
        dispatch(message(e.message));
      });
  };

  useEffect(() => {
    console.log("formData", formData)
    fetchData();
  }, [refresh]);

  if (isLoading) {
    return <div>Loading...</div>;
  }


  return (
    <div className=""> {/* Add some padding around the entire content */}
      {/* Upload Academic Calendar Section */}
      {/* Delete pop up */}

      <DeleteModal
        title="Delete Academics"
        message="Are you sure you want to delete Academics?
It will erase all the data permanently."
        modalOpenDelete={modalForm}
        setmodalOpenDelete={setModalForm}
        handleDelete={handleDelete} // Don't call it here
        selectedId={idToDelete}
        setSelectedId={setIdToDelete}
        modalOpenDeleteSuccess={modalOpenDeleteSuccess}
        setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
        module={"Academics"}
        redirectPage={"Education"}
        redirectUrl={'/education'}

      />

      <h2 className="text-lg text-black  font-semibold mb-2">Upload Your Academic Calendar</h2>
      <p className="text-gray-600 text-sm mb-4">It should be in PNG or JPG form</p>
      <div className="bg-white rounded-[20px] p-4 shadow mb-6"> {/* Added margin-bottom */}

        {/* Drag and Drop Area */}
        <div className=" border-gray-300 relative rounded-lg p-16 text-center text-gray-500 hover:border-gray-400 transition duration-300 ease-in-out">
          <input type="file" id="academic-calendar-upload" accept=".png,.jpg,.jpeg" className="hidden" />
          <label className="flex flex-col items-center justify-center  border-purple-500 cursor-pointer overflow-hidden">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"
              disabled={(formData?._id && formData?.image)} 
            />
            {previewURL ? (
              <div className='bg-white '>
                <div className="absolute top-3 right-3">
                  <button onClick={() => toggleMenu()}>
                    <img
                      src={HiOutlineDotsVertical}
                      className="text-black-500 hover:text-black"
                    />
                  </button>

                  {openMenu && (
                    <div className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10">
                      <button
                        className="block w-full text-left px-3 rounded-b-xl rounded-t-xl py-2 text-sm hover:bg-gray-100"
                        onClick={() => {
                          if (formData?._id && formData.image !== previewURL) {
                            setRefresh(!refresh);
                            return;
                          }
                          setIdToDelete(formData._id);
                          setModalForm(true);
                        }}

                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
                <img
                  src={previewURL || formData?.image}
                  alt="Preview"
                  className="w-full h-full object-cover "
                />
              </div>
            ) : (
              <span className="text-primary_main font-medium">+ Upload Image</span>
            )}
            {/* {formData?.image ? (<div className='bg-white '>
              <div className="absolute top-3 right-3">
                <button onClick={() => toggleMenu()}>
                  <img
                    src={HiOutlineDotsVertical}
                    className="text-black-500 hover:text-black"
                  />
                </button>

                {openMenu && (
                  <div className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10">
                    <button
                      className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                      onClick={() => {
                        setIdToDelete(formData._id);
                        setModalForm(true);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                )}
              </div>
              <img
                src={formData?.image}
                alt="image"
                className="w-full h-full object-cover "
              />
            </div>) : previewURL ? (<div className='bg-white '>
              <img
                src={previewURL}
                alt="Preview"
                className="w-full h-full object-cover "
              />
            </div>
            ) : (<span className="text-primary_main font-medium">+ Upload Image</span>)} */}
          </label>

        </div>

        {/* Upload Button */}

      </div>
      {!(formData?._id && formData?.image) && (
        <div className="mt-12 mb-10 flex flex-col justify-center items-center">
          {addPermission && (
            <button
              onClick={handleSave}
              disabled={!previewURL}
              className={`bg-primary_main w-[347px] text-white px-8 py-3 rounded-lg font-semibold transition duration-300 ease-in-out ${!previewURL ? 'hover:cursor-not-allowed' : ""}`}
            >
              Upload
            </button>
          )}
          {imageSizeMsg && <div className="text-red-500 text-lg  mt-2">{imageSizeMsg}</div>}
        </div>
      )}


      {/* <div className="mt-12 mb-10 flex justify-center">
        {addPermission && (
          <div>
            <button
              className="flex items-center justify-center font-bold bordercursor-pointer px-20 py-3 rounded-md text-white bg-purple-600"
              onClick={() => document.getElementById('fileInput').click()}
            >
              Upload
            </button>
            <input
              id="fileInput"
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"
            />
          </div>
        )}
      </div> */}

      {/* Main Calendar Section */}
      <MainCalendar />
    </div>
  )
}

export default Academic